import { CrossPortCallsConditionBM } from '../types/BusinessModel/CrossPortCallsConditionBM';
import { CrossPortCallsCondition } from '../types/ViewModel/CrossPortCallsCondition';

export class CrossPortCallsConditionFactory {
    constructor() {}

    public newCrossPortCallsConditionArray(crossPcCondList: CrossPortCallsConditionBM[]): CrossPortCallsCondition[] {
        const crossPortCallsConditionList: CrossPortCallsCondition[] = [];
        if (crossPcCondList && crossPcCondList.length > 0) {
            crossPcCondList.map((cmItem) => {
                crossPortCallsConditionList.push(this.createCrossPortCallsConditionItem(cmItem));
            });
        }
        return crossPortCallsConditionList;
    }

    private createCrossPortCallsConditionItem(item: CrossPortCallsConditionBM): CrossPortCallsCondition {
        return new CrossPortCallsCondition(item.crossPortCallsConditionId, item.nextEventTypeGroupId, item.previousEventTypeGroupId);
    }
}
